module.exports = __webpack_public_path__ + "assets/img/24_1082.8219764b.jpg";